

import Model from './Model'
import Project from './Project'
import User from "./User";

export default class Document extends Model
{
	static Key = 'Document';

	static UploadForProjectRequest;
	static UpdateForProjectRequest;
	static ArchiveForProjectRequest;

	static normalize(props) {
	    if (props.causer) {
	        props.causer = User.make(props.causer);
        }

	    return props;
    }
	resolve() {
        if (this.isTypeContract() && !this.notes) {
            this.notes = 'Created by Wripple';
        }
        return super.resolve();
    }

    static async uploadForProject(project, props)
	{
		let user = TB.auth().user();
		if (!user
			|| !user.hasRegisteredClientOrg()) {
			return;
		}

		this.UploadForProjectRequest = TB.request(
			TB.api_endpoint(
				`/api/clients/${user.clientOrg().id}/projects/${project.id}/documents/create`
			),
			{...props}
		);

		this.UploadForProjectRequest = this.UploadForProjectRequest.headers({
            'Content-Type': 'multipart/form-data',
        });

		let response = await this.UploadForProjectRequest.post().catch(console.warn);

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data.document)
		{
			let didHandleError = await this.UploadForProjectRequest.handleError();
            if (didHandleError
                && this.UploadForProjectRequest.shouldRerun) {
                return this.uploadForProject(project, props);
            }

			return;
		}

		let newDocument = this.make(response.success.data.document);

		project = Project.make({...project});
		project.documents.push({...newDocument});

		Project.refreshCacheFor(project);

		return newDocument;
	}

	async updateForProject(project)
	{
		let user = TB.auth().user();
		if (!user
			|| !user.hasRegisteredClientOrg()) {
			return;
		}

		this.constructor.UpdateForProjectRequest = TB.request(
			TB.api_endpoint(
				`/api/clients/${user.clientOrg().id}/projects/${project.id}/documents/${this.id}/update`
			), {
				name: this.name,
				type: this.type,
			}
		);

		let response = await this.constructor.UpdateForProjectRequest.post().catch(console.warn);

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data.document)
		{
			let didHandleError = await this.constructor.UpdateForProjectRequest.handleError();
            if (didHandleError
                && this.constructor.UpdateForProjectRequest.shouldRerun) {
                return this.updateForProject(project);
            }

			return;
		}

		let updatedDoc = {...response.success.data.document};

		let updatedProject = Project.make({...project});
		let newDocuments = [];
		for (let i in updatedProject.documents) {
			if (updatedProject.documents[i].id == updatedDoc.id) {
				newDocuments.push(updatedDoc);
			}
			else {
				newDocuments.push(updatedProject.documents[i]);
			}
		}
		updatedProject.documents = newDocuments;

		Project.refreshCacheFor(updatedProject);

		return this;
	}

	async archiveForProject(project)
	{
		let user = TB.auth().user();
		if (!user
			|| !user.hasRegisteredClientOrg()) {
			return;
		}

		this.constructor.ArchiveForProjectRequest = TB.request(
			TB.api_endpoint(
				`/api/clients/${user.clientOrg().id}/projects/${project.id}/documents/${this.id}/delete`
			)
		);

		let response = await this.constructor.ArchiveForProjectRequest.post().catch(console.warn);

		if (!response
			|| !response.success)
		{
			let didHandleError = await this.constructor.ArchiveForProjectRequest.handleError();
            if (didHandleError
                && this.constructor.ArchiveForProjectRequest.shouldRerun) {
                return this.archiveForProject(project);
            }

			return;
		}

		project = Project.make({...project});
		let newDocuments = [];
		for (let i in project.documents) {
			if (project.documents[i].id != this.id) {
				newDocuments.push(project.documents[i]);
			}
		}
		project.documents = newDocuments;

		Project.refreshCacheFor(project);

		return this;
	}

    static typeContract() {
        return parseInt(TB.invert(laravel.document_types)['Contract'])
    }
    static typeSignedContract() {
        return parseInt(TB.invert(laravel.document_types)['Signed Contract'])
    }
    static typeGeneratedContract() {
        return parseInt(TB.invert(laravel.document_types)['Auto-Generated Contract'])
    }
    static typeClientRevisedProposal() {
        return parseInt(TB.invert(laravel.document_types)['Revised Proposal'])
    }


    isTypeContract() {
	    return this.type === Document.typeContract()
    }

    isTypeSignedContract() {
        return this.type === Document.typeSignedContract()
    }

	isTypeGeneratedContract() {
		return this.type === Document.typeGeneratedContract()
	}

    isTypeClientRevisedProposal() {
	    return this.type === Document.typeClientRevisedProposal()
    }

	getFileSize() {
		let bytes = this.size, decimals = 2;
		if (!bytes) return null;
		if (bytes === 0) return '0 Bytes';

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}
    getFileIcon() {
        let lastDot = TB.isString(this.path) ? this.path.lastIndexOf('.') : -1;

        if (lastDot === -1) {
            return 'file-alt';
        }

        let ext = this.path.substring(lastDot + 1);

        switch (ext) {
            case 'csv':
                return 'file-csv'
            case 'ppt':
            case 'ppxt':
                return 'file-powerpoint'
            case 'xls':
            case 'xlsx':
                return 'file-excel'
            case 'doc':
            case 'docx':
                return 'file-word'
            case 'pdf':
                return 'file-pdf';
            default:
                return 'file-alt';
        }
    }


}